import store from "@/store/BookingStore"
import { NavigationHookAfter } from "vue-router"
import router from "."
import { CatalogManagerApi } from "@/service/CatalogApiService/CatalogManagerApi"

const afterEachRoute: NavigationHookAfter = async (to, from, next) => {
    const token = store.state.token

    // Already in the URL? Do nothing
    if (!token || to.query.token === token) return

    // Avoid re-applying
    if (to.meta.tokenPatched) return

    router.replace({
        path: to.path,
        query: { token }
    })

    // Optional: mark this route so you don't re-apply it forever
    to.meta.tokenPatched = true


}

export default afterEachRoute